import { useCallback, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { LANGUAGE_KEYS } from 'config/languageKeys';

import { AppNotification } from 'components/Notification/types';

type Params = {
    isLive: boolean;
    livePosition: number | undefined;
};

const {
    ALERT_TIMESHIFT_NOT_YET_AVAILABLE_DESCRIPTION,
    ALERT_TIMESHIFT_NOT_YET_AVAILABLE_TITLE,
    PLAYER_ACTION_NOT_ALLOWED_TITLE,
    PLAYER_ACTION_NOT_ALLOWED_BODY,
} = LANGUAGE_KEYS;
const TRICKMODE_DISABLED_DURATION = 60;

const useDisabledNotifications = ({ isLive, livePosition }: Params) => {
    const { t } = useTranslation();
    const isSOTSPauseDisabled =
        isLive &&
        livePosition != null &&
        livePosition <= TRICKMODE_DISABLED_DURATION;

    const [disabledNotification, setDisabledNotification] = useState<
        AppNotification | undefined
    >();

    const onResetDisabledNotification = useCallback(() => {
        if (disabledNotification) {
            setDisabledNotification(undefined);
        }
    }, [disabledNotification]);

    const onShowTimeshiftNotAvailableNotification = useCallback(() => {
        setDisabledNotification({
            title: t(ALERT_TIMESHIFT_NOT_YET_AVAILABLE_TITLE),
            description: t(ALERT_TIMESHIFT_NOT_YET_AVAILABLE_DESCRIPTION),
        });
    }, [t]);

    const onShowControlsRestrictedNotification = useCallback(() => {
        setDisabledNotification({
            title: t(PLAYER_ACTION_NOT_ALLOWED_TITLE),
            description: t(PLAYER_ACTION_NOT_ALLOWED_BODY),
        });
    }, [t]);

    return {
        isSOTSPauseDisabled,
        disabledNotification,
        onShowTimeshiftNotAvailableNotification,
        onShowControlsRestrictedNotification,
        onResetDisabledNotification,
    };
};

export default useDisabledNotifications;
